export const verticalValues = ['top', 'bottom', 'center'];
export const horizontalValues = ['left', 'right', 'center'];

export const defaultAnchorOrigin = {
	vertical: 'top',
	horizontal: 'left',
};

export const defaultTransformOrigin = {
	vertical: 'top',
	horizontal: 'right',
};
